import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircleIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { EbookMockup } from '../components/EbookMockup';
import { BenefitItem } from '../components/BenefitItem';
import { Footer } from '../components/Footer';
export function Upsell2Page() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleAccept = () => {
    navigate('/thank-you');
  };
  const handleDecline = () => {
    navigate('/thank-you');
  };
  return <div className="min-h-screen bg-wellness-cream flex flex-col" data-id="element-264">
      {/* Top Warning Bar */}
      <div className="bg-wellness-gold text-white text-center py-3 px-4 font-bold tracking-wide flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-265">
        <AlertCircleIcon className="w-5 h-5 animate-pulse" data-id="element-266" />
        <span data-id="element-267">ÚLTIMA OPORTUNIDAD - Oferta Exclusiva</span>
        <CountdownTimer initialSeconds={300} className="bg-white/20 border-none text-white py-1" data-id="element-268" />
      </div>

      <div className="flex-grow py-12 px-4" data-id="element-269">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-wellness-darkBeige" data-id="element-270">
          <div className="p-8 md:p-12" data-id="element-271">
            <div className="text-center mb-10" data-id="element-272">
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-wellness-dark" data-id="element-273">
                Añade 30 Recetas Saludables Extra a Tu Colección
              </h1>
              <p className="text-xl text-wellness-body" data-id="element-274">
                Más variedad, más sabor, más salud en tu mesa cada día para que
                nunca te aburras.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-275">
              <div className="flex justify-center" data-id="element-276">
                <EbookMockup title="Recetas Saludables" subtitle="Volumen 2" variant="accent" className="scale-110" data-id="element-277" />
              </div>

              <div data-id="element-278">
                <h3 className="text-2xl font-bold mb-6" data-id="element-279">
                  Amplía tu menú semanal
                </h3>
                <div className="space-y-4 mb-8" data-id="element-280">
                  <BenefitItem text="30 nuevas opciones para almuerzos y cenas" data-id="element-281" />
                  <BenefitItem text="Ingredientes económicos y accesibles" data-id="element-282" />
                  <BenefitItem text="Opciones vegetarianas y con proteína animal" data-id="element-283" />
                  <BenefitItem text="Evita el estancamiento en tu dieta" data-id="element-284" />
                  <BenefitItem text="Sorprende a tu familia con nuevos sabores" data-id="element-285" />
                </div>

                <div className="bg-wellness-beige p-6 rounded-2xl text-center" data-id="element-286">
                  <p className="text-wellness-body mb-2" data-id="element-287">
                    Precio Normal: <span className="line-through" data-id="element-288">€27</span>
                  </p>
                  <p className="text-xl mb-1" data-id="element-289">Oferta Única Hoy:</p>
                  <p className="text-5xl font-bold text-wellness-primary mb-6" data-id="element-290">
                    €9.90
                  </p>

                  <CTAButton onClick={handleAccept} className="w-full mb-4" data-id="element-291">
                    ¡Agregar a Mi Pedido!
                  </CTAButton>

                  <button onClick={handleDecline} className="text-wellness-body hover:text-wellness-dark underline text-sm transition-colors" data-id="element-292">
                    No gracias, ir a mis descargas
                  </button>
                </div>
              </div>
            </div>

            <GuaranteeSection data-id="element-293" />
          </div>
        </div>
      </div>

      <Footer data-id="element-294" />
    </div>;
}